// web/src/store/phone/_audio.ts —— 内部：远端媒体绑定（PeerConnection 取流播放）
// 拆自 web/src/store/phone.ts 的同名分区（内容原样搬运）；由 web/src/store/phone.ts 以 export * 聚合，导出面对调用方不变。

import { Invitation, Inviter, Registerer, RegistererState, Session, SessionState, TransportState, UserAgent, UserAgentRegisteredOptionTags } from 'sip.js';

import { bindSession } from './_session';
import { rt } from './_state';


export function setupRemoteAudio(s: Session) {
  try {
    const pc: RTCPeerConnection | undefined = (s.sessionDescriptionHandler as any)?.peerConnection;
    if (!pc) return;
    if (!rt.audio) {
      const el = document.createElement('audio');
      el.autoplay = true;
      el.setAttribute('playsinline', '');
      // 挂到 DOM：分离元素在某些浏览器下 autoplay/play 行为异常（被叫听不到主叫，已实测复现）
      document.body.appendChild(el);
      rt.audio = el;
    }
    const attach = (streams?: readonly MediaStream[], track?: MediaStreamTrack) => {
      const stream = streams?.[0] || (track ? new MediaStream([track]) : undefined);
      if (!rt.audio || !stream || !stream.getTracks().length) {
        console.warn('[phone] attach skip', !!stream, stream?.getTracks().length);
        return;
      }
      rt.audio.srcObject = stream;
      // autoplay 兜底：先 muted 播放（muted 不受自动播放策略限制，必然成功），
      // 启动后短暂延迟取消静音出声——被叫端听不到主叫的根因修复，不依赖用户手势
      rt.audio.muted = true;
      rt.audio
        .play()
        .then(() => {
          window.setTimeout(() => {
            try {
              rt.audio!.muted = false;
            } catch {
              /* 已挂断 */
            }
          }, 300);
        })
        .catch(() => undefined);
    };
    pc.ontrack = (ev) => attach(ev.streams, ev.track);
    // 竞态修复：被叫的 INVITE 带 SDP 时，SIP.js 可能在 bindSession 设置 ontrack 之前
    // 就 setRemoteDescription 并触发 ontrack 事件，这里补挂已存在的接收轨道（已实测确认
    // 被叫方向 recvTracks 存在但 ontrack 未触发 → 无声）
    try {
      const existing = (pc.getReceivers?.() || [])
        .map((r) => r.track)
        .filter((t): t is MediaStreamTrack => !!t);
      if (existing.length) {
        attach(undefined, existing[0]);
      }
    } catch {
      /* 忽略 */
    }
  } catch {
    /* 忽略媒体绑定失败 */
  }
}

